import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { motion } from "framer-motion";
import { ArrowLeft, Home } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden font-quicksand">
      {/* Background Image */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-auxis-charcoal" />
      </div>

      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="relative z-10 text-center px-6"
      >
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.5 }}
          className="mb-8"
        >
          <span className="text-[150px] md:text-[200px] font-bold text-white/10 leading-none block">404</span>
        </motion.div>
        
        <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">Page introuvable</h1>
        <p className="text-xl text-white/70 mb-8 max-w-md mx-auto">
          Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
        </p>
        
        <Link 
          to="/" 
          className="group inline-flex items-center justify-center gap-3 px-8 py-4 bg-auxis-gold text-auxis-charcoal rounded-xl font-semibold hover:bg-yellow-500 transition-all duration-300 shadow-lg"
        >
          <Home size={18} />
          Retour à l'accueil
        </Link>
      </motion.div>
    </div>
  );
};

export default NotFound;
